import { useOktaAuth } from '@okta/okta-react'
import axios from 'axios'
import { api } from 'config'
import { useEffect, useState } from 'react'

export function useMemberData() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string>('')
  const [data, setData] = useState<TMember[]>([])

  const { authState } = useOktaAuth()

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true)
        const response = await axios.get<TMember[]>(api.getAllowableMembers(), {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        setData(response.data)
        setLoading(false)
      } catch (error: any) {
        setLoading(false)
        setError(JSON.stringify(error))
      }
    }
    getData()
  }, [authState?.accessToken?.accessToken])

  return { loading, data, error }
}
